const categoryDangerRouter = [
    {
        path: "dangers",
        name: "category_danger",
        component: () => import("@/views/admin/category-danger"),
        default: true,
        meta: {
            model: "category_danger",
            // requiresAuth: true,
        },
    },
    {
        path: "dangers/add",
        name: "addCategoryDanger",
        component: () => import("@/views/admin/category-danger/function"),
        default: true,
        meta: {
            model: "category_danger",
            // requiresAuth: true,
        },
    },
    {
        path: "dangers/edit/:id",
        name: "editCategoryDanger",
        component: () => import("@/views/admin/category-danger/function"),
        default: true,
        meta: {
            model: "category_danger",
            // requiresAuth: true,
        },
    }
]
export default categoryDangerRouter;